import React, { useState } from "react";
import { Drawer, Button } from "antd";
import Sidebar from "./Sidebar";

export default function SidebarDrawer({ openProfile, loading }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Hamburger */}
      <Button
        onClick={() => setOpen(true)}
        style={{
          position: "fixed",
          top: 16,
          left: 16,
          zIndex: 1000,
        }}
      >
        ☰
      </Button>

      <Drawer
        placement="left"
        open={open}
        onClose={() => setOpen(false)}
        bodyStyle={{ padding: 0 }}
        width={220}
      >
        <Sidebar openProfile={openProfile} loading={loading} />
      </Drawer>
    </>
  );
}
